// extracted by mini-css-extract-plugin
export var aircallIframe = "_ct-3";
export var fabContainer = "_ct-5";
export var fabRinging = "_ct-6";
export var loadingOverlay = "_ct-4";
export var pulse = "_ct-7";
export var widgetContent = "_ct-2";
export var widgetPanel = "_ct-0";
export var widgetPanelExpanded = "_ct-1";